// Shared formatters for the billing pages (Subscriptions + Invoice History).

/**
 * Peso amount: 5000 → "₱5,000.00".
 *
 * Delegates to the app-wide formatter (BL-082) so these pages match the
 * dashboard Billing-estimate card that links here — previously this rendered
 * whole pesos while the card rendered 2 decimals.
 */
export { formatPeso as peso } from "./currency";

/**
 * Format a Firestore Timestamp | Date | millis | ISO string → "Jun 4, 2026"
 * (en-PH). Returns "—" for null/undefined.
 */
export const fmtDate = (ts) => {
  const d = ts?.toDate ? ts.toDate() : ts ? new Date(ts) : null;
  return d
    ? d.toLocaleDateString("en-PH", { year: "numeric", month: "short", day: "numeric" })
    : "—";
};
